var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUndo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_undo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_undo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_reset",
    transform: "translate(8.000000, 7.500000) scale(-1, 1) rotate(-270.000000) translate(-8.000000, -7.500000) translate(2.500000, -0.500000)",
    fill: "#2F2F2F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.63429048,0.23766463 L7.72471605,0.324949121 L10.0039549,2.81593701 C10.3302216,3.17251506 10.3513216,3.70514831 10.071244,4.08434355 L9.98739501,4.18370863 L7.5948117,6.67469652 C7.21223419,7.07300907 6.57919771,7.08576484 6.18088516,6.70318732 C5.81321203,6.35003884 5.77406067,5.78348155 6.07112054,5.38512491 L6.15239436,5.28926077 L7.146315,4.25467966 C7.07945619,4.25197421 7.01236491,4.25061614 6.94506836,4.25061614 C4.25285035,4.25061614 2.07037643,6.43309006 2.07037643,9.12530807 C2.07037643,11.8175261 4.25285035,13.9999967 6.94506836,13.9999967 C8,13.9999967 8,15.9999967 6.94506836,15.9999967 C3.14828085,15.9999967 0.0703764289,12.9220956 0.0703764289,9.12530807 C0.0703764289,5.38449368 3.05819942,2.34152274 6.77762527,2.25261538 L6.24917896,1.67505663 C5.90503567,1.29894126 5.90248788,0.731038533 6.22460926,0.352659901 L6.31189375,0.262234328 C6.68800912,-0.0819089583 7.25591185,-0.0844567543 7.63429048,0.23766463 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2F2F2F",
    cx: 15,
    cy: 10,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2F2F2F",
    x: 14,
    y: 9,
    width: 2,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUndo);
export default __webpack_public_path__ + "static/media/icon_undo.fff4f0b4d4ca6e304feb1f834628bf46.svg";
export { ForwardRef as ReactComponent };